import OverlayRenderer from './overlay-renderer';
import MediaUtil from './media-util';
//LAZY import {fabric} from 'fabric';
import * as log from 'loglevel';


class ProductRenderer extends OverlayRenderer {

    _findProductUrl(layer, context){

        let product = context.product;

        // NEW: manual img position - overwrites variant setting
        if(layer.params.imgPos){
            let position = parseInt(layer.params.imgPos);
            // make sure index is valid
            if(!isNaN(position) && product.images.length > (position-1)){
                return product.images[position - 1];
            }
        }

        // NEW: filename template match e.g. 'shirt_{option1}' - no match falls through to variant/featured
        if(layer.params.imgTemplate && product.images){
            let variant = MediaUtil.findVariant(product, context.variantId);
            let resolved = MediaUtil.resolve(layer.params.imgTemplate, variant, context.options);
            let url = resolved && MediaUtil.findImage(product.images, resolved);

            if(url){
                return url;
            }

            log.debug('imgTemplate: no image for ', resolved || layer.params.imgTemplate);
        }

        // flag to enable variant updates
        if(layer.params.variant){
            let variant = MediaUtil.findVariant(product, context.variantId);

            // always return variant image - imgPos only used if variant=false
            if(variant && variant.featured_image?.src){
                return variant.featured_image.src;
            }
        }

        // default featured product image
        return product.featured_image;
    }

    _getImage(layer, context, canvas, params = layer.params) {

        if(context.product){

            let productUrl = this._findProductUrl(layer, context);

            if(productUrl){
                // only use cached if url has not changed
                if(layer._object && layer._url === productUrl){
                    return Promise.resolve(layer._object);
                } else {
                    return new Promise((resolve, reject) => {

                        // NEW: image url with CDN size to dimension on preview (used to scale down large images)
                        let imageUrl = this._getImageUrl(productUrl, layer, context);

                        fabric.Image.fromURL(imageUrl, (fabricImg) => {

                            if (fabricImg === undefined) {

                                log.warn('product url not found: ', productUrl);

                                // still resolve and not reject to continue rendering
                                resolve(null);
                            }

                            // cache url
                            layer._url = productUrl;

                            resolve(fabricImg);
                        }, { crossOrigin: 'anonymous'}); // crossOrigin required for canvas export support

                    });
                }
            }

        } else {
            log.warn('missing product in render context');
        }

        return Promise.resolve(null);
    }
}

export default ProductRenderer;